import React, { useEffect, useState } from 'react';
import './settings.css';
import { DrugExceptionsClient } from '../../../client/drug-exceptions-client';
import { useNavigate } from 'react-router-dom';
import GetLangConfig from '../../../util/LangUtil';
import FormatDateLocale from '../../../util/DateUtil';
import { TextField } from '@mui/material';
import { useLanguage } from '../../../context/LanguageContext';

interface HandleError {
    handleError: Function;
}

export default function ClaimantSettings(props: HandleError) {
    const userId = JSON.parse(sessionStorage.getItem('userId') || 'null');
    const userIdentityObject = JSON.parse(sessionStorage.getItem('userIdentityObject') || 'null');
    const history = useNavigate();
    const language = useLanguage();
    const langConfig = GetLangConfig('settings');
    const client = new DrugExceptionsClient();

    const [currentPassword, setCurrentPassword] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [password2, setPassword2] = useState<string>('');
    const [passwordError, setPasswordError] = useState<boolean>(false);

    let gender = langConfig.settings.other;

    if(userIdentityObject.gender == 'MALE')
        gender = langConfig.settings.male;
    else if(userIdentityObject.gender == 'FEMALE')
        gender = langConfig.settings.female;

    useEffect(() => {
        if (password !== '' && password2 !== '') {
            const passwordsMatch = password === password2;
            setPasswordError(!passwordsMatch);
        } else {
            setPasswordError(false);
        }
    }, [password, password2]);

    const changePassword = async () => {
        if (currentPassword !== '' && password !== '' && password2 !== '') {
            if (password !== password2) {
                props.handleError({
                    error: true,
                    ajax: {
                        request: {
                            responseText: [langConfig.settings.pwdmsg6]
                        }
                    }
                });
                return;
            }

            try {
                const payload = {
                    oldPassword: currentPassword,
                    newPassword: password
                };

                const response = await client.api.post('/users/changepassword', payload, {
                    headers: {
                        Authorization: `Bearer ${userId.authToken}`
                    }
                });

                props.handleError({
                    error: false,
                    ajax: {
                        request: {
                            responseText: ['Password changed successfully']
                        }
                    }
                });

            } catch(error) {
                props.handleError(error);
            }
        } else {
            props.handleError({
                error: true,
                ajax: {
                    request: {
                        responseText: [langConfig.settings.pwdmsg5]
                    }
                }
            });
            return;
        }
    };

    return (
        <div className="claimant-settings-container">
            <div className='header'>
                <h1>{langConfig.settings.label1}</h1>
            </div>
            <div className='settings'>
                <div className='account-details'>
                    <h1>{langConfig.settings.label2}</h1>
                    <h3>{userIdentityObject.firstName} {userIdentityObject.lastName}</h3>
                    <div className='detail-group'>
                        <div className='detail-label'>{langConfig.settings.label3}:</div>
                        <div className='detail-info'>{gender}</div>
                    </div>
                    <div className='detail-group'>
                        <div className='detail-label'>{langConfig.settings.label4}</div>
                        <div className='detail-info'>{FormatDateLocale(new Date(userIdentityObject.dateOfBirth), language)}</div>
                    </div>
                    <div className='detail-group'>
                        <div className='detail-label'>{langConfig.general.email}:</div>
                        <div className='detail-info'>{userIdentityObject.identity.email}</div>
                    </div>
                    <div className='detail-group'>
                        <div className='detail-label'>{langConfig.general.phone}:</div>
                        <div className='detail-info'>{userIdentityObject.identity.phoneNumber}</div>
                    </div>
                </div>
                <div className='plan-member-details'>
                    <h1>{langConfig.settings.label5}</h1>
                    <h3>{userIdentityObject.memberFirstName} {userIdentityObject.memberLastName}</h3>
                    <div className='detail-group'>
                        <div className='detail-label'>{langConfig.general.policynum}:</div>
                        <div className='detail-info'>{userIdentityObject.policyNumber}</div>
                    </div>
                    <div className='detail-group'>
                        <div className='detail-label'>{langConfig.general.certificatenum}:</div>
                        <div className='detail-info'>{userIdentityObject.certificateNumber}</div>
                    </div>
                </div>
                <div className='change-password'>
                    <h1>{langConfig.settings.label6}</h1>
                    <TextField
                        id="current-password"
                        label={`${langConfig.settings.pwdtext1}*`}
                        type="password"
                        variant="filled"
                        margin="normal"
                        fullWidth
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        onBlur={(e) => setCurrentPassword(e.target.value)}
                    />
                    <TextField
                        id="password"
                        label={`${langConfig.settings.pwdtext2}*`}
                        type="password"
                        variant="filled"
                        margin="normal"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        error={passwordError}
                        helperText={passwordError ? langConfig.settings.pwdmsg6 : ''}
                    />
                    <TextField
                        id="password2"
                        label={`${langConfig.settings.pwdtext3}*`}
                        type="password"
                        variant="filled"
                        margin="normal"
                        fullWidth
                        value={password2}
                        onChange={(e) => setPassword2(e.target.value)}
                        error={passwordError}
                        helperText={passwordError ? langConfig.settings.pwdmsg6 : ''}
                    />
                    <div>
                        <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped " onClick={changePassword}>
                            <div className="mdc-button__ripple"></div>
                            <span className="mdc-button__label">{langConfig.settings.label7}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}